export function composeScreenError(displayMSG, logMSG, code){
	const error = {
		displayMSG,
		logMSG,
		code
	};
	return error;
}
